import { clinic } from '../data/clinic';
interface BrandMarkProps {
  size?: 'sm' | 'lg';
  className?: string;
}
export function BrandMark({
  size = 'sm',
  className = ''
}: BrandMarkProps) {
  const large = size === 'lg';
  return <span className={`inline-flex flex-col items-start ${className}`} aria-label={`${clinic.brandName} ${clinic.brandTagline}`} data-id="element-6" data-mp="tkdlpqfl4ae7">
      <span className={`font-display uppercase leading-none text-cream-50 ${large ? 'text-4xl tracking-[0.3em] sm:text-5xl' : 'text-lg tracking-[0.26em]'}`} data-id="element-7" data-mp="omc0ayuoryzk">
        {clinic.brandName}
      </span>
      <span className={`font-sans uppercase text-gold-400 ${large ? 'mt-3 text-[11px] tracking-widest2' : 'mt-1.5 text-[8px] tracking-[0.22em]'}`} data-id="element-8" data-mp="1chojf6lkivrj">
        {clinic.brandTagline}
      </span>
    </span>;
}